import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import Swal from "sweetalert2";
import { addEmailToCartMailChimp, apiMail } from "../actions/userActions";
import { ContactResponse } from "../emails/new";

const PopupOffer = ({ show, setShow, force, setForce }) => {
	const [email, setEmail] = useState("");
	const [name, setName] = useState("");
	const [showForm, setShowForm] = useState(false);
	const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

	const handleClose = () => {
		localStorage.setItem("showPopup", new Date().getTime());
		setShow(false);
		setForce(false);
	};

	const checkTime = () => {
		if (force) {
			setShow(true);
			return false;
		}
		const storedTime = localStorage.getItem("showPopup");
		if (!storedTime) return false;
		const daysDifference =
			(new Date().getTime() - storedTime) / (1000 * 3600 * 24);
		return daysDifference < 7;
	};

	function splitFullName(fullName) {
		const nameRegex = /^(\S+)\s+(.+)$/;
		const match = fullName.trim().match(nameRegex);

		if (match) {
			return {
				fname: match[1],
				lname: match[2],
			};
		} else {
			return {
				fname: fullName,
				lname: "-",
			};
		}
	}

	const sendGiftCard = async (e) => {
		e.preventDefault();
		try {
			alert("Thank you! We'll send you a promo code shortly via email.");
			await addEmailToCartMailChimp(email, "New Promo 10%", name, "-");
			await apiMail(
				email,
				`10% OFF PROMO CODE FROM OFF CUT SHADES`,
				<ContactResponse
					name={splitFullName(name)["fname"]}
					promo={true}
					promoCode={"10PROMO"}
				/>
			);
			handleClose();
		} catch (error) {
			console.log("Error sending gift card:", error);
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "An unexpected error occurred. Please contact info@offcutshades.com.",
			});
		}
	};

	useEffect(() => {
		if (force) {
			setShow(true);
		} else if (!checkTime()) {
			setTimeout(() => {
				setShow(true);
			}, 5000);
		}
	}, [force]);

	return (
		<div className="w-full">
			{show && (
				<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
					<div
						className={`relative flex bg-white rounded-lg shadow-lg overflow-hidden ${
							isMobile ? "flex-col" : "flex-row"
						}`}
					>
						<div className={`${isMobile ? "h-1/2 w-full" : "w-1/2"}`}>
							<img
								src="/images/popup_left.png"
								className="w-full h-full object-cover"
								alt="Popup"
							/>
						</div>
						<div className="relative bg-gray-900 text-white flex flex-col items-center justify-center p-8 w-full lg:w-1/2">
							<button className="absolute top-4 right-4" onClick={handleClose}>
								<img
									src="/images/icons/exit_icon.png"
									alt="Close"
									className="w-6 h-6"
								/>
							</button>
							<h2 className="text-4xl lg:text-6xl font-bold text-center">
								You Get An <br />{" "}
								<span className="text-primary">Extra 10% Off</span>
							</h2>
							<h3 className="text-lg lg:text-2xl text-center my-4 font-medium">
								<i>Get your shades for an even better price</i>
							</h3>
							{!showForm ? (
								<>
									<button
										className="bg-primary text-white text-lg lg:text-2xl font-semibold py-3 px-6 rounded-full my-4"
										onClick={() => setShowForm(true)}
									>
										Claim Your 10% Off Promo Code
									</button>
									<button
										className="text-gray-300 text-sm lg:text-lg italic"
										onClick={handleClose}
									>
										No, I do not want an additional 10% Off
									</button>
								</>
							) : (
								<form
									className="flex flex-col w-full max-w-md space-y-3"
									onSubmit={sendGiftCard}
								>
									<input
										className="w-full px-4 py-2 rounded-full text-black"
										type="text"
										placeholder="Name"
										required
										value={name}
										onChange={(e) => setName(e.target.value)}
									/>
									<input
										className="w-full px-4 py-2 rounded-full text-black"
										type="email"
										placeholder="Email"
										required
										value={email}
										onChange={(e) => setEmail(e.target.value)}
									/>
									<button
										className="bg-primary text-white text-lg font-semibold py-3 rounded-full"
										type="submit"
									>
										Claim Now
									</button>
								</form>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default PopupOffer;
